import toast from "react-hot-toast";
import i18next from "i18next";
import {BaseClient} from "../../Api/HttpClient";
import {transformObjectToGetRequestParams} from "../../Utils/HttpHelper";

export const createPerformanceStatementsSlice = (set, get) => ({
    performanceStatements: [],
    performanceStatementsMetaData: [],
    performanceStatementDetail: {},

    getMyPerformanceStatements: async (status = [], page = 1, searchFilter = '') => {
        const filters = status?.length > 0 ? status.join(',') : null;
        let params = {page: page};
        if(filters !== null) {
            params.status = filters;
        }
        if (searchFilter) {
            params.search = searchFilter;
        }

        await BaseClient().get('/performance-statements?' +  transformObjectToGetRequestParams(params))
            .then(response => {
                if (response.status === 200) {
                    set({performanceStatements: response.data?.data})
                    set({performanceStatementsMetaData: response.data?.meta})
                } else {
                    toast.error(response.data);
                }
            })
    },
    getPerformanceStatement: async (performanceStatementId) => {
        await BaseClient().get(`/performance-statements/${performanceStatementId}`)
            .then(response => {
                if (response.status === 200) {
                    set({performanceStatementDetail: response.data})
                } else {
                    toast.error(response.data);
                }
            })
    },
    acceptPerformanceStatement: async (performanceStatementId, data) => {
        await BaseClient().post(`/performance-statements/${performanceStatementId}/accept`, data)
            .then(response => {
                if (response.status === 200) {
                    return response.data
                } else {
                    toast.error(response.data);
                }
            })
    },
    rejectPerformanceStatement: async (performanceStatementId, data) => {
        await BaseClient().post(`/performance-statements/${performanceStatementId}/reject`, data)
            .then(response => {
                if (response.status === 200) {
                    return response.data
                } else {
                    toast.error(response.data);
                }
            })
    },
    regeneratePerformanceStatement: async (performanceStatementId) => {
        await BaseClient().post(`/performance-statements/${performanceStatementId}/regenerate`)
            .then(response => {
                if (response.status === 200) {
                    toast.success(i18next.t('performance_reports.toast_regenerate_success'));
                } else {
                    toast.error(response.data);
                }
            })
    },

    getPerformanceStatementsForUser: async (userId, page = 1, branchId = null) => {
        try {
            const params = new URLSearchParams();
            params.append('page', page);

            if (branchId) {
                params.append('branch_id', branchId);
            }

            const response = await BaseClient().get(`/users/${userId}/performance-statements?${params.toString()}`);
            if (response.status === 200) {
                return {
                    data: response.data?.data || [],
                    meta: response.data?.meta || {}
                };
            } else {
                toast.error(response.data);
                return { data: [], meta: {} };
            }
        } catch (error) {
            console.error('Error fetching performance statements for user:', error);
            toast.error(i18next.t('performance_reports.toast_fetch_error'));
            return { data: [], meta: {} };
        }
    },

    generatePerformanceStatement: async (freelancerId, data) => {
        try {
            const response = await BaseClient().post(`/freelancers/${freelancerId}/generate-performance-statement`, data);
            if (response.status === 200) {
                toast.success(response.data?.message || i18next.t('performance_reports.toast_generate_success'));
                return { success: true };
            } else {
                toast.error(response.data?.message || i18next.t('general.errors.generic'));
                return { success: false };
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || i18next.t('performance_reports.toast_generate_error');
            toast.error(errorMessage);
            return { success: false };
        }
    }
})